import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const CardContainer = styled(Box)(() => ({
  padding: '8px 14px',
  borderBottom: '1px solid #D7D8DB',
  display: 'flex',
  justifyContent: 'space-between',
}));

export const FlexBox = styled(Box)(() => ({
  display: 'flex',
  gap: '4px',
  alignItems: 'center',
}));

export const NumberTypography = styled(Typography)(({ theme }) => ({
  fontSize: '16px',
  fontWeight: '600',
  color: theme.palette.secondary.main,
}));

export const TitleTypography = styled(Typography)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  padding: '4px',
  fontSize: '16px',
}));

export const IconTypography = styled(Typography)(({ theme }) => ({
  display: 'flex',
  '& span': {
    fontSize: '21px',
    color: theme.palette.secondary.main,
    fontWeight: '600',
  },
}));
